/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Contact_Can_Deny_ContactsInputs */

const en_forms_users_settings_contact_can_deny_contacts = /** @type {(inputs: Forms_Users_Settings_Contact_Can_Deny_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

const de_forms_users_settings_contact_can_deny_contacts = /** @type {(inputs: Forms_Users_Settings_Contact_Can_Deny_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer kann Kontakte ablehnen`)
};

/**
* | output |
* | --- |
* | "Contacts" |
*
* @param {Forms_Users_Settings_Contact_Can_Deny_ContactsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_contact_can_deny_contacts = /** @type {((inputs?: Forms_Users_Settings_Contact_Can_Deny_ContactsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Contact_Can_Deny_ContactsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_contact_can_deny_contacts(inputs)
	return de_forms_users_settings_contact_can_deny_contacts(inputs)
});